var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"i_maxW"},[_c('ul',{staticClass:"links clear"},_vm._l((_vm.links.slice(0,5)),function(item,key){return _c('li',{key:key},[_c('a',{attrs:{"href":item.link_url}},[_vm._v(_vm._s(item.name))])])}),0),_c('foote')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }